import React, { Suspense, useRef, useState, useEffect } from "react"
import { Canvas, useFrame, useLoader, useThree} from "@react-three/fiber"
import { ContactShadows, Environment, useGLTF, Sphere, Text, useProgress, OrbitControls, PointerLockControls, PerspectiveCamera } from "@react-three/drei"
import { VRCanvas, Hands, useXR, DefaultXRControllers } from '@react-three/xr'
import { RGBMLoader } from "three-stdlib"
import * as THREE from 'three'
import { Stars } from './StarsVR'
import { VRButton } from "./VRButton"
import Player from './Player'

function Sound({ url, sphere }) {
  const sound = useRef()
  const { scene } = useThree()
  const { isPresenting } = useXR()
  const [listener] = useState(() => new THREE.AudioListener())
  const buffer = useLoader(THREE.AudioLoader, url)
  const play = () => {
    sound.current.play()
  }
  useEffect(() => {
    // console.log('New camera')
    document.addEventListener('click', play)
    sound.current.setBuffer(buffer)
    sound.current.setRefDistance(1)
    sound.current.setLoop(true)
    
    scene.add(listener)
    return () => {
      scene.remove(listener)
      document.removeEventListener('click', play)
    }
  }, [])

  useFrame(({camera}) => {
    camera.matrixWorld.decompose(listener.position, listener.quaternion, listener.scale)
  })
  return <positionalAudio ref={sound} args={[listener]} />
}

useLoader.preload(RGBMLoader, ['Text.002_denoised_encoded.png', 'Plane.001_denoised_encoded.png'])
useGLTF.preload('poem2.glb')

function Model(props) {
  const group = useRef()
  const [lightmap, lightmap1] = useLoader(RGBMLoader, ['Text.002_denoised_encoded.png', 'Plane.001_denoised_encoded.png'])
  const { nodes } = useGLTF('poem2.glb', './')
  
  lightmap.encoding = THREE.RGBM7Encoding;
  lightmap.flipY = false;
  const mat = new THREE.MeshBasicMaterial({ map: lightmap })

  lightmap1.encoding = THREE.RGBM7Encoding;
  lightmap1.flipY = false;
  const mat1 = new THREE.MeshBasicMaterial({map: lightmap1})

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.Text002.geometry} material={mat} position={nodes.Text002.position} />
      <mesh geometry={nodes.Plane001.geometry} position={nodes.Plane001.position} material={mat1} />
      <mesh geometry={nodes.Sphere.geometry} position={nodes.Sphere.position} />
      
    </group>
  )
}

function Loader() {
  const { progress } = useProgress()
  return <Text font="Roboto-Regular.woff" position={[0, 1, -3]} center>Won't be long now...</Text>
}

export default function App() {
  const controlsRef = useRef()
  const orbitControlsRef = useRef()
  const sphereRef = useRef()
  return (
    <>
      <VRCanvas dpr={[1, 1.5]} camera={{ position: [20, 1, -1.5], fov: 50 }} onCreated={({ gl }) => {
        VRButton.createButton(gl)
      }}>
        <Stars />
        <Player controlsRef={controlsRef} orbitControlsRef={orbitControlsRef} />
        <ambientLight intensity={0.1} />
        <pointLight intensity={10} angle={0.1} penumbra={1} position={[-158.66236877441406, 75.27489471435547, -187.94981384277344]} castShadow />

        <Suspense fallback={<Loader />}>
        <group position={[14, 5, 15.5]}>
          <Sound sphere={sphereRef} url="song.m4a" />
        </group> 
          <Model />
        </Suspense>
        <PointerLockControls ref={controlsRef} selector="#enterflat" />
        <OrbitControls minPolarAngle={-Math.PI/2} maxPolarAngle={+Math.PI/2} ref={orbitControlsRef} autoRotate={false} autoRotateSpeed={0.2} enableZoom={true} target={[0, 1, -1.5]} enablePan={false} enabled={true} />
      </VRCanvas>
    </>
  )
}
